define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.GrazingPermitTypeDomain = void 0;
    class GrazingPermitTypeDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: GrazingPermitTypeDomain.Emergency, value: "Emergency" },
                    { key: GrazingPermitTypeDomain.ShortTerm, value: "Short Term" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[GrazingPermitTypeDomain.Emergency] = 0;
                this.KeyIndex[GrazingPermitTypeDomain.ShortTerm] = 1;
                this.ValueIndex = {};
                this.ValueIndex["Emergency"] = 0;
                this.ValueIndex["Short Term"] = 1;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.GrazingPermitTypeDomain = GrazingPermitTypeDomain;
    Object.defineProperty(GrazingPermitTypeDomain, "Emergency", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(GrazingPermitTypeDomain, "ShortTerm", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(GrazingPermitTypeDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
